import React from 'react';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/server';
import { Grid, Input, Dropdown } from 'semantic-ui-react';
import Button from '@material-ui/core/Button';
import BranchDetails from './branchdetails';
import CustomerType from '../../dropdown/type';

class Settings extends React.Component {

  state = {
    data: [],
    branch: [],
    key1points: 0,
    key2points: 0,
    selectedBranch: 0,
  }

  componentDidMount() {
    this.get();
  }


  getCustomerType() {
    alert('hi')
  }

  get() {
    let context = this;
    context.setState({
      load: true,
      message: 'Getting Points'
    });
    $.ajax({
      type: "POST",
      url: Server() + 'settings/get.php',
      success: function(data)
      {
        context.setState({
          load: false,
        });
        try {
          data = JSON.parse(data);
          let points = [];
          let branch = [];
          data.map((x) => {
            if (x.type == 'points') {
              points.push(x);
            }
            else {
              branch.push(x);
            }
          })
          points.map((v) => {
            if (v.branch == 0 && v.empid == -1) {
              context.setState({ key1points: v.points })
            }
            if (v.branch == 0 && v.empid == -2) {
              context.setState({ key2points: v.points })
            }
          })
          context.setState({ data: points, branch: branch })
          context.setBranch(branch);
        } catch (e) {
          alert('Error');
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    })
  }

  setBranch(data) {
    let context = this;
    var x = [];
    data.map((y) => {
      x.push({key: y.id+'->'+y.branch, text: y.id+'->'+y.branch, value: y.id});
    });
    this.setState({ branchOption: x })
  }

  texthandling = (type) => event => {
    let value = event.target.value;
    value = Number(value);
    if (value > 100 || value < 0) {
      alert('Value is more then 100 or Less then 0!!!');
      return;
    }
    let data = this.state.data;
    if (type == 'key1points') {
      data.map((z) => {
        if (z.empid == -1) {
          z.points = event.target.value
        }
      })
    }
    else {
      data.map((z) => {
        if (z.empid == -2) {
          z.points = event.target.value
        }
      })
    }
    this.setState({ [type]: event.target.value, data: data })
  }

  branch = event => {
    let value = event.target.value;
    let dropDown = event.target.value;
    value = value.split('->')[0];
    this.setState({ selectedBranch: value, dropDown: dropDown });
  }

  onChange = (type) => (f, { value }) => {
    this.setState({ selectedBranch: value });
  }

  update(type, value, alldata) {
    this.setState({ customertype: value, allcustomertypedata: alldata })
  }

  render() {
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <div style={{padding: '2%'}}>
          <Grid>
            <Grid.Column mobile={16} tablet={16} computer={5}>
              <b>Branch</b><br/>
              <Dropdown fluid
                id="Type" onChange={this.onChange('type')} placeholder="Branch"
                search selection options={this.state.branchOption}
                value={this.state.selectedBranch} fluid style={{ borderColor: '#5A9CBB' }} />
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={5}>
              { this.state.selectedBranch ?
                (
                  <div>
                    <b>Customer Type</b><br/>
                    <CustomerType update={this.update.bind(this)} />
                  </div>
                ) :
                (
                  <div></div>
                )
              }
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={16}>
              <BranchDetails branch={this.state.selectedBranch} customertype={this.state.customertype} maindata={this.state.data} />
            </Grid.Column>
          </Grid>
          <br/>
        </div>
      </div>
    );
  }
}

export default Settings;
